module.exports = __webpack_public_path__ + "img/img2.b17986c3.png";